import React, {Component, createRef, Fragment} from 'react'
import moment from 'moment'
import {forecastShipBatchStatisticsCSV} from '../../../services/api/apiBarcode'
import downloadCsv from '../../../components/ExportCSV/downloadCsv'
import {Spin} from "antd"

class Table extends Component {
    state = {
        loadings: {}
    }
    containerRows = createRef()

    componentDidMount() {
        this.props.setContainerRows(this.containerRows)
    }

    formatNumber = (number) => {
        const chunks = []
        const numbers = `${number}`.split('').reverse()

        for (let i = 0; i < numbers.length; i += 3) {
            chunks.push(numbers.slice(i, i + 3).reverse().join(''))
        }

        return chunks.reverse().join(',')
    }

    formatDate = (d) => {
        return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }

    isExporting = (col, row) => {
        return this.state.loadings[row] && this.state.loadings[row][col]
    }

    getExportUrl = (col, row) => (e) => {
        e.preventDefault()

        if (this.isExporting(col, row)) {
            return
        }

        this.setState({
            loadings: {
                ...this.state.loadings,
                [row]: {
                    ...this.state.loadings[row],
                    [col]: true
                }
            }
        })
        forecastShipBatchStatisticsCSV({shipping_carrier: row, col})
            .then(csv => {
                downloadCsv(csv).then(() => {
                    this.setState({
                        loadings: {
                            ...this.state.loadings,
                            [row]: {
                                ...this.state.loadings[row],
                                [col]: false
                            }
                        }
                    })
                })
            })
    }

    colContent = (carrierSlug, col, num) => {
        const isExporting = this.isExporting(col, carrierSlug)

        return isExporting
            ? <>
                <i className="fa fa-refresh spinner" style={{marginRight: '5px'}}/>
                <span>{this.formatNumber(num)}</span>
            </>
            : (num > 0
                    ? <a href=""
                         onClick={this.getExportUrl(col, carrierSlug)}>{this.formatNumber(num)}</a>
                    : <span>{this.formatNumber(num)}</span>
            )
    }

    render() {
        const {
            mappingCarriers,
            notShipped,
            overdue,
            expectedCompletion,
            totalOrders,
            totalWeight,
        } = this.props

        return <table className="ForecastShipTable">
            <thead>
            <tr>
                <th className="ColCarrier">Shipping Carrier</th>
                <th className="ColOrderWeight">Đơn / Kg</th>
                <th className="ColTotal number">Tổng</th>
                <th colspan="2" className="ColNotShipped number" style={{textAlign: 'center'}}>Chưa ship</th>
                {
                    expectedCompletion.map((row, index) => {
                        return <th key={row.date} className="ColDate number">
                            {index === 0 ? 'Hôm nay' : this.formatDate(row.date)}
                        </th>
                    })
                }
            </tr>
            </thead>
            <tbody ref={this.containerRows}>
            {
                mappingCarriers.map((carrier, i) => {
                    const [carrierSlug, carrierName] = carrier

                    return <Fragment key={`group-${i}`}>
                        <tr key={`${carrierSlug}-orders`}
                            className={[carrierSlug, i % 2 === 0 ? 'Odd' : 'Even', 'Row Orders'].join(' ')}>
                            <td data-col="shipping_carrier" className="ColCarrier" rowSpan={2}>{carrierName}</td>
                            <td data-col="order_weight" className="ColOrderWeight">Số đơn</td>
                            <td data-col="total" className="ColTotal number total">{
                                this.formatNumber(totalOrders[carrierSlug])
                            }</td>
                            <td data-col="not_shipped" className="ColNotShipped number">
                                {this.colContent(carrierSlug, 'notShipped', notShipped[carrierSlug].total)}
                            </td>
                            <td data-col="overdue" className="ColOverdue number">
                                {this.colContent(carrierSlug, 'overdue', overdue && overdue[carrierSlug] ? overdue[carrierSlug].total : 0)}
                            </td>
                            {
                                expectedCompletion.map((row, index) => {
                                    return <td data-col={`date_${index}`} className="ColDate number"
                                               key={`${carrierSlug}-orders-${row.date}`}>
                                        {
                                            this.colContent(carrierSlug, row.date, row[carrierSlug].total)
                                        }
                                    </td>
                                })
                            }
                        </tr>
                        <tr key={`${carrierSlug}-weight`}
                            className={[carrierSlug, i % 2 === 0 ? 'Odd' : 'Even', 'Row Weight'].join(' ')}>
                            <td data-col="order_weight">Khối lượng (kg)</td>
                            <td data-col="total" className="number total">
                                {this.formatNumber(totalWeight[carrierSlug])}
                            </td>
                            <td data-col="not_shipped" className="ColNotShipped number">
                                {
                                    this.colContent(carrierSlug, 'notShipped', notShipped[carrierSlug].weight_in_kg)
                                }
                            </td>
                            <td data-col="overdue" className="ColOverdue number">
                                {
                                    this.colContent(carrierSlug, 'overdue', overdue && overdue[carrierSlug] ? overdue[carrierSlug].weight_in_kg : 0)
                                }
                            </td>
                            {
                                expectedCompletion.map((row, index) => {
                                    return <td data-col={`date_${index}`} className="number"
                                               key={`${carrierSlug}-weight-${row.date}`}>
                                        {
                                            this.colContent(carrierSlug, row.date, row[carrierSlug].weight_in_kg)
                                        }
                                    </td>
                                })
                            }
                        </tr>
                    </Fragment>
                })
            }
            </tbody>
        </table>
    }
}

export default Table